<template>
	<div>
		<!-- 联系我们 -->
		<div class="all-center-box">
		    <div class="w-1500">
				<div class="address-box w-100"><router-link to="/">首页</router-link> / <router-link to="/about">关于汇利兴</router-link></div>
				<div class="page-center-box w-100">
					<div class="page-left">
						<div class="box-info1 w-100">关于汇利兴</div>
						<div class="box-info2 w-100">
							<router-link to="/about">公司简介</router-link>
							<router-link to="/contact">联系我们</router-link>
						</div>
					</div>
					<div class="page-right">
						<div class="content-box w-100">
							<baidu-map class="top-box w-100" :zoom="zoom" :center="center" @ready="handler" :ak="ak">
								<!-- <bm-marker :position="center" name=""></bm-marker> -->
							</baidu-map>
							<div class="lower-box w-100">
								<ul>
									<li>
										<i><img src="../../assets/images/icon_16.png" ></i>
										<span>地址</span>
										<p>重庆市九龙坡区西彭镇森迪大道8号2幢</p>
									</li>
									<li>
										<i><img src="../../assets/images/icon_17.png" ></i>
										<span>电话</span>
										<p>023-68617887   68617883</p>
									</li>
									<li>
										<i><img src="../../assets/images/icon_18.png" ></i>
										<span>传真</span>
										<p>023-68619776</p>
									</li>
									<li>
										<i><img src="../../assets/images/icon_19.png" ></i>
										<span>联系人</span>
										<p>13637773033（胡先生）</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
	export default{
		name:'contact',
		components:{
			BaiduMap
		},
		data() {
			return{
				center:{
					lng:0,
					lat:0,
				},
				ak:'O4aFVMSLVl1aiTX2sF40aVfC',
				zoom:3
			}
		},
		methods:{
			handler({BMap,map}){
				this.center.lng = 106.330254;
				this.center.lat = 29.329152;
				this.zoom = 15;
			}
		}
	}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/contact/contact.vue